/**
 * Created by stonewang on 2018/2/28.
 */
import Reflux from 'reflux';

/*消息*/
export const MsgActions = Reflux.createActions([
  'updateState',
  'paramChange',
]);

export class MsgStore extends Reflux.Store {
  constructor()
  {
    super();
    this.state = {
      useStore: false,
      params: {
        s: 10,
        p: 1
      }
    };
    this.listenables = MsgActions;
  }
  updateState(data){
    this.setState({
      ...this.state,
      ...data
    });
  }
  paramChange(data){
    this.setState({
      ...this.state,
      params:{
        ...this.state.params,
        ...data
      }
    });
  }
}
/*收藏*/
export const CollectActions = Reflux.createActions([
  'updateState',
  'paramChange',
]);

export class CollectStore extends Reflux.Store {
  constructor()
  {
    super();
    this.state = {
      useStore: false,
      params: {
        s: 10,
        p: 1
      }
    };
    this.listenables = CollectActions;
  }
  updateState(data){
    this.setState({
      ...this.state,
      ...data
    });
  }
  paramChange(data){
    this.setState({
      ...this.state,
      params:{
        ...this.state.params,
        ...data
      }
    });
  }
}
/*订单*/
export const OrderActions = Reflux.createActions([
  'setFormPage',
  'updateState',
  'paramChange',
]);

export class OrderStore extends Reflux.Store {
  constructor()
  {
    super();
    this.state = {
      useStore: false,
      productList: [],
      logisticsEvaluation: {},
      params: {
        s: 10,
        p: 1
      }
    };
    this.listenables = OrderActions;
  }
  updateState(data){
    this.setState({
      ...this.state,
      ...data
    });
  }
  paramChange(data){
    this.setState({
      ...this.state,
      params:{
        ...this.state.params,
        ...data
      }
    });
  }
  setFormPage ({detail, orderProductId}) {
    let productList = [];
    let logisticsEvaluation = {};
    if(orderProductId){
      productList = detail.productList.filter(x => x.id === orderProductId).map(x => ({
        'productPicUrl': x.picUrl,
        'productName': x.productName,
        'productSpec': x.specUnionKey,
        'price': x.price,
        'orderProductId': x.id,
        'orderId': detail.id,
        'score': 0,
        'evaluation': '',
        'picFileIdList': [],
        'picFileList': [],
      }))
    }else{
      productList = detail.productList.map(x => ({
        'productPicUrl': x.picUrl,
        'productName': x.productName,
        'productSpec': x.specUnionKey,
        'price': x.price,
        'orderProductId': x.id,
        'orderId': detail.id,
        'score': 0,
        'evaluation': '',
        'picFileIdList': [],
        'picFileList': [],
      }));
      logisticsEvaluation = {
        'orderId': detail.id,
        'packScore': '', /* 商品包装 */
        'speedScore': '', /* 送货速度 */
        'attitudeScore': '' /* 配送员服务态度 */
      };
    }
    localStorage.setItem('EvaluatePage', JSON.stringify({logisticsEvaluation, productList}))
  }
}

/*订单*/
export const ExchangeActions = Reflux.createActions([
  'updateState',
  'paramChange',
]);

export class ExchangeStore extends Reflux.Store {
  constructor()
  {
    super();
    this.state = {
      useStore: false,
      productList: [],
      logisticsEvaluation: {},
      params: {
        s: 10,
        p: 1
      }
    };
    this.listenables = ExchangeActions;
  }
  updateState(data){
    this.setState({
      ...this.state,
      ...data
    });
  }
  paramChange(data){
    this.setState({
      ...this.state,
      params:data
    });
  }
}


// WEBPACK FOOTER //
// ./src/mall/userCenter/store.js